(function () {
  var lastTrigger = null;

  function drawer() {
    return document.querySelector('[data-amirio-guide]');
  }

  function detach() {
    var el = drawer();
    if (el && el.parentElement !== document.body) document.body.appendChild(el);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', detach);
  else detach();

  function open(trigger) {
    var el = drawer();
    if (!el) return;

    lastTrigger = trigger || null;
    el.hidden = false;
    requestAnimationFrame(function () {
      el.classList.add('is-open');
    });
    document.documentElement.style.overflow = 'hidden';

    var close = el.querySelector('.amirio-guide__close');
    if (close) close.focus();
  }

  function close() {
    var el = drawer();
    if (!el || el.hidden) return;

    el.classList.remove('is-open');
    document.documentElement.style.overflow = '';

    var done = function () {
      el.hidden = true;
      el.removeEventListener('transitionend', done);
    };
    el.addEventListener('transitionend', done);
    setTimeout(done, 400);

    if (lastTrigger) lastTrigger.focus();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;

    var opener = target.closest('[data-amirio-open-guide]');
    if (opener) {
      event.preventDefault();
      open(opener);
      return;
    }

    if (target.closest('[data-amirio-close-guide]')) {
      event.preventDefault();
      close();
      return;
    }

    var unit = target.closest('[data-amirio-unit]');
    if (unit) {
      var wanted = unit.dataset.amirioUnit;
      var panel = unit.closest('.amirio-size-guide');
      if (!panel) return;

      panel.querySelectorAll('[data-amirio-unit]').forEach(function (button) {
        button.classList.toggle('is-active', button === unit);
      });
      panel.querySelectorAll('td[data-cm]').forEach(function (cell) {
        cell.textContent = wanted === 'in' ? cell.dataset.in : cell.dataset.cm;
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });
})();
